import { Sparkles, ShieldCheck, Workflow } from 'lucide-react';

const valueProps = [
  {
    icon: Sparkles,
    title: 'AI-guided',
    description: 'Our AI walks you through every step.',
  },
  {
    icon: ShieldCheck,
    title: 'Compliant by design',
    description: 'Built as a Qualified Intermediary + RIA from day one.',
  },
  {
    icon: Workflow,
    title: 'Done end-to-end',
    description: 'Sale, identification, escrow, replacement — one platform.',
  },
];

export function ValueProps() {
  return (
    <section
      className="py-20 px-4 border-t border-border"
      aria-label="Platform features"
    >
      <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-10">
        {valueProps.map(({ icon: Icon, title, description }) => (
          <article
            key={title}
            className="flex flex-col items-center text-center gap-4"
          >
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary">
              <Icon className="h-6 w-6" aria-hidden="true" />
            </div>
            <h2 className="text-base font-semibold text-foreground">{title}</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
